import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { SideMenuLinkIconBase } from "./base/side-menu-link-icon-base.box";

const JackpotsSideMenuDefaultIcon = styled(SideMenuLinkIconBase)`
    background-position: ${({active}) => active ? "-571px -480px" : "-571px -451px"};
`;

const JackpotsSideMenuHarrahsIcon = styled(JackpotsSideMenuDefaultIcon)`
    background-position: ${({active}) => active ? "-562px -413px" : "-562px -387px"};
`;

const JackpotsSideMenuWsopIcon = styled(JackpotsSideMenuDefaultIcon)`
    background-position: ${({active}) => active ? "-561px -413px" : "-561px -387px"};
`;

const JackpotsSideMenuCasino777Icon = styled(JackpotsSideMenuDefaultIcon)`
    background-position: ${({active}) => active ? "-83px -525px" : "-83px -582px"};
    &:hover {
        background-position: -83px -554px;
    }
`;

export const JackpotsSideMenuIcon = styledByTheme(JackpotsSideMenuDefaultIcon)
    .forCasino777(JackpotsSideMenuCasino777Icon)
    .forHarrahs(JackpotsSideMenuHarrahsIcon)
    .forWsop(JackpotsSideMenuWsopIcon).apply();

